module.exports = __webpack_public_path__ + "static/img/tj8.a8ef56d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tj8.png
// module id = Cv0v
// module chunks = 0